import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Alert, CircularProgress } from '@mui/material';
import api from '../utils/api';
import { SplitAuthLayout, AmberButton, AuthInput } from '../components/design';

const MONO = "'IBM Plex Mono', monospace";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setIsSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <SplitAuthLayout statusLine="// reset access · link expires in 60 min">
      {isSubmitted ? (
        <>
          <Box sx={{ width: '48px', height: '48px', borderRadius: '12px', background: 'rgba(68,208,123,.14)', border: '1px solid rgba(68,208,123,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: '20px' }}>
            <Box component="span" sx={{ fontSize: '22px' }}>✉</Box>
          </Box>
          <Box component="h1" sx={{ m: 0, mb: '12px', fontSize: '24px', fontWeight: 700, color: '#f4f8ff', letterSpacing: '-.01em' }}>
            Check your inbox
          </Box>
          <Box sx={{ mb: '28px', fontSize: '14.5px', color: '#8fa3c6', lineHeight: 1.6 }}>
            If an account exists for <Box component="span" sx={{ color: '#dce6fa', fontFamily: MONO }}>{email}</Box>, we've sent a reset link. Check your spam folder if it doesn't arrive within a few minutes.
          </Box>
          <AmberButton to="/login" size="lg" fullWidth>Back to Log in</AmberButton>
        </>
      ) : (
        <>
          <Box component="h1" sx={{ m: 0, mb: '6px', fontSize: '24px', fontWeight: 700, color: '#f4f8ff', letterSpacing: '-.01em' }}>
            Forgot password
          </Box>
          <Box sx={{ mb: '26px', fontSize: '14.5px', color: '#8fa3c6' }}>
            Enter your email and we'll send a reset link.
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: '20px', background: 'rgba(244,113,106,.1)', color: '#f4a39e', border: '1px solid rgba(244,113,106,.3)', '& .MuiAlert-icon': { color: '#f4716a' } }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ display: 'flex', flexDirection: 'column', gap: '22px' }}>
            <AuthInput label="Email" id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" autoComplete="email" autoFocus required disabled={loading} />
            <AmberButton size="lg" fullWidth disabled={loading || !email} onClick={handleSubmit}>
              {loading ? <CircularProgress size={18} sx={{ color: '#241200' }} /> : 'Send reset link'}
            </AmberButton>
          </Box>

          <Box sx={{ mt: '22px', textAlign: 'center', fontSize: '13.5px', color: '#8298bd' }}>
            Remember it?{' '}
            <Box component={RouterLink} to="/login" sx={{ color: '#2dd4bf', textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#5fe6d6' } }}>
              Log in
            </Box>
          </Box>
        </>
      )}
    </SplitAuthLayout>
  );
};

export default ForgotPassword;
